module.exports = __webpack_public_path__ + "static/media/points-history-icon.247bc1f0.svg";